<div class="mat-elevation-z8 ccorbit-mat-table col-settings-wrapper" [cdkContextMenuTriggerFor]="context_menu">

  <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
       [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
      <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
    </div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column of tableColumns">
        <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">
          {{column.name}}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <cdk-virtual-scroll-viewport #brokerView id="brokerView" item [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34"
    class="wrapperBroker mat-elevation-z2 tableStyle" [style.height]="alto">
    <table cdk-table [dataSource]="brokPosdata" class="table-striped tableStyle">

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
        [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
      <ng-container *ngFor="let tablecol of tableColumns">

        <ng-container [cdkColumnDef]="tablecol.id">
          <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header" (click)="orderByField(tablecol.id)">
            {{tablecol.name}}
          </th>
          <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                            'entrada': item[tablecol.id] === 'ENTRADA',
                                                            'numero-positivo': item[tablecol.id] > 0,
                                                            'numero-negativo': item[tablecol.id] < 0
                                                            }">
            <ng-container *ngIf="tablecol.isString &&  tablecol.id !== 'hora' && tablecol.id !== 'horaCotizacion' && tablecol.id !== 'lastExecutionTimer'">
              {{item[tablecol.id]}} <ng-container *ngIf="tablecol.id === 'nombreCompania'">
                {{item['secType'] === 'CFD' ? ' CFD' : ''}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="tablecol.isDate">
              {{item[tablecol.id] | smartDate }}
            </ng-container>
            <ng-container *ngIf="tablecol.isNumber">
              {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentradareal' || tablecol.id === 'cotizacion') ? '1.5-5' : '1.2-2')}}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'hora'">
              {{ formatHoraCotizacion(item['hora'])}}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'horaCotizacion'">
              {{ formatHoraCotizacion(item['horaCotizacion'])}}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'lastExecutionTimer'">
              {{ formatFechaHoraCotizacion(+item['lastExecutionTimer'])  }}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'idOrdenEntrada'">
              {{ idOrdenEntrada(item) }}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'entradaApiBroker' && operacionDe(item) as op">
              {{ sltp.formatPrice(op.precioentradareal, op) }} / {{ sltp.formatPrice(op.precioentradabroker, op) }}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'spread' && operacionDe(item) as op">
              {{ sltp.formatPrice((op.precioentradabroker - op.precioentradareal) * op.cantidadacciones * op.contractsize, op) }}
            </ng-container>
          </td>
        </ng-container>
      </ng-container>

      <ng-container cdkColumnDef="select">
        <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">
          <mat-checkbox (change)="toggleTodas()" [checked]="todasSeleccionadas()"
            [indeterminate]="seleccion.hasValue() && !todasSeleccionadas()"></mat-checkbox>
        </th>
        <td cdk-cell *cdkCellDef="let item">
          <mat-checkbox *ngIf="operacionDe(item)" (click)="$event.stopPropagation()"
            (change)="seleccion.toggle(item.isooper)" [checked]="seleccion.isSelected(item.isooper)"></mat-checkbox>
        </td>
      </ng-container>
    </table>
  </cdk-virtual-scroll-viewport>
</div>

<ng-template #context_menu let-data="data">
  <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
    <button class="example-menu-item" (click)="verModelo()" cdkMenuItem>
      <mat-icon class="menu-icon">open_in_new</mat-icon>
      <span>Ver Modelo</span>
    </button>
    <button class="example-menu-item" (click)="verGrafica()" cdkMenuItem>
      <mat-icon class="menu-icon">insert_chart</mat-icon>
      <span>Ver Gráfica</span>
    </button>
    <button class="example-menu-item" (click)="openDialog()" cdkMenuItem>
      <mat-icon class="menu-icon">exit_to_app</mat-icon>
      <span>Operaciones de Salida</span>
    </button>
    <ng-container *ngIf="controlOperativa">
      <button class="example-menu-item" (click)="accionSlTp('establecerSL')" cdkMenuItem>
        <mat-icon class="menu-icon">shield</mat-icon>
        <span>Establecer Stop Loss</span>
      </button>
      <button class="example-menu-item" (click)="accionSlTp('actualizarSL')" cdkMenuItem>
        <mat-icon class="menu-icon">trending_up</mat-icon>
        <span>Actualizar Stop Loss</span>
      </button>
      <button class="example-menu-item" (click)="accionSlTp('cancelarSL')" cdkMenuItem>
        <mat-icon class="menu-icon">remove_moderator</mat-icon>
        <span>Cancelar Stop Loss</span>
      </button>
      <button class="example-menu-item" (click)="accionSlTp('establecerTP')" cdkMenuItem>
        <mat-icon class="menu-icon">flag</mat-icon>
        <span>Establecer Profit</span>
      </button>
      <button class="example-menu-item" (click)="accionSlTp('cancelarTP')" cdkMenuItem>
        <mat-icon class="menu-icon">outlined_flag</mat-icon>
        <span>Cancelar Profit</span>
      </button>
    </ng-container>
  </div>
</ng-template>
